import { Component } from '@angular/core';
import { FocusConfig, ICON_TYPE } from '@spartacus/storefront';
import { Subscription } from 'rxjs';
import { GenLaunchDialogService } from 'src/app/generac/services/launch-dialog.service';

@Component({
  selector: 'gen-ff-mixed-cart-dialog',
  templateUrl: './ff-mixed-cart-dialog.component.html',
  standalone: false
})
export class GenFFMixedCartDialogComponent {
  focusConfig: FocusConfig = {
    trap: true,
    block: true,
    autofocus: 'button',
    focusOnEscape: true,
  };

  iconTypes = ICON_TYPE;

  protected subscription = new Subscription();

  constructor(
    protected launchDialogService: GenLaunchDialogService,
  ) { }

  dismiss(reason?: any): void {
    this.launchDialogService.closeDialog(reason, 'CHECKOUT_FF_MIXED_CART_DIALOG');
  }
}
